// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://gbvnvdysosdstpxvocxy.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imdidm52ZHlzb3Nkc3RweHZvY3h5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3Mzg1NzU0MjgsImV4cCI6MjA1NDE1MTQyOH0.24V_IUbuNn41gdQwszSvaHpVae-LGTklyszwwwfhhKQ";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);